import { useIntl } from "react-intl";

import { useMutation } from "@tanstack/react-query";

import { Zotero } from "../../../api/zotero";
import { MutationKey } from "../../../consts/mutation-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { ApiError } from "../../../types/api-error";
import { ApiHookConfig } from "../../../types/api-hook-config";

export const useZoteroSync = ({ onSuccess }: ApiHookConfig) => {
  const { formatMessage } = useIntl();

  const { handleSuccess } = useApiSuccess({
    snackbarText: formatMessage({
      id: "REFERENCES.SYNC_ZOTERO_STARTED",
      defaultMessage: "Zotero synchronization started",
      description: "Success message when Zotero sync starts",
    }),
    onSuccessFn: onSuccess,
  });

  const { handleError } = useApiError();

  const mutationFn = () => Zotero.sync();

  const { mutate: syncZotero, isPending } = useMutation({
    mutationKey: [MutationKey.SyncZotero],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: (error: ApiError) => {
      if (error.Status === 429) {
        // Override the default error handling for 429 status
        handleError({
          ...error,
          Body: {
            ...error.Body,
            GenericErrors: ["Zotero synchronization is already running"],
          },
        });
      } else {
        handleError(error);
      }
    },
  });

  return { syncZotero, isPending };
};
